import BaseErrorHandler from '../../shared-lib/communication/BaseErrorHandler'
import { CALLER_HANDLED_ERROR_CODES, FormattedError } from '../../shared-lib/communication/ErrorHelper'

export default class ErrorHandler extends BaseErrorHandler {
  get location() {
    return this.store.pathname
  }

  get userId() {
    return this.store.userStore.data._id
  }

  get userEmail() {
    return this.store.userStore.data.emailAddress
  }

  expiredCodes = ['AUTH_TOKEN_EXPIRED', 'AUTH_NO_HEADER_FOUND']

  trackInAnalytics = (_error: FormattedError) => {
    // TODO
    // Analytics.track('Error Message', { code: error.code, error })
  }

  showErrorInUI = (error: FormattedError) => {
    if (CALLER_HANDLED_ERROR_CODES.includes(error.code)) return

    if (error.code === 'SERVER_CONNECTION_ERROR') {
      this.store.uiStore.showNetworkError(error)
      return
    }

    this.store.uiStore.showToast(error.message)
  }

  handleExpiredSession = async () => {
    const {
      authStore,
    } = this.store

    authStore.setSessionExpired(true)
    authStore.clearData()
  }
}